<nav class="navbar navbar-expand-lg fixed-top navbar-transparent" color-on-scroll="500">
	<div class="container-fluid">
		<div class=" w-100">
			<div class="col-lg-10 offset-lg-1">
				<div class="menu-container" style="width:100%;">
					<div class="d-flex justify-content-between menu-block">
						<div class="brand">
							<a href="/" routerLinkActive="router-link-active">
								<img *ngIf="showBlackbars() && ifblackbar" src="{{baseUrl}}/img/logos/pixtar-main-logo.webp"
									alt="Branding agency in Dubai " width="160" height="50" class="logo1" loading="lazy">
								<img *ngIf="showBlackbars() && ifwhitebar" src="{{baseUrl}}/img/logos/pixtar-main-logo-white.webp"
									alt="Creative agency Dubai" width="160" height="" class="logo1" loading="lazy">
								<img *ngIf="showBlackbars() && ifblackbar" src="{{baseUrl}}/img/logos/pixtar-black-logo.svg"
									alt="rebranding agency dubai" width="40" height="" class="logo2" loading="lazy">
								<img *ngIf="showBlackbars() && ifwhitebar" src="{{baseUrl}}/img/logos/pixtar_white.svg"
									alt="best web design company in dubai" width="40" height="" class="logo2" loading="lazy"></a>
						</div>
						<div class="menu-list">
							<a href="/" routerLinkActive="router-link-active">
								<img *ngIf="showBlackbars() && ifblackbar" src="{{baseUrl}}/img/home/home.png"
									alt="web designing agency dubai" height="23" width="25" class="home-icon" (mouseenter)="func()"
									(mouseleave)="func2()" loading="lazy">
								<img *ngIf="showBlackbars() && ifwhitebar" src="{{baseUrl}}/img/home/homewhite.png"
									alt="Top branding agency in Dubai" height="23" width="25" class="home-icon" (mouseenter)="func()"
									(mouseleave)="func3()" loading="lazy">
							</a>
							<input type="checkbox" id="burger-toggle">
							<label for="burger-toggle" class="burger-menu" (click)="labelchange()">
								<div class="line"></div>
								<div class="line"></div>
								<div class="line"></div>
							</label>
							<div class="labelmenu">
								<h3 *ngIf="showBlackbars() && ifblackbar" class="cstmenu showcls">Close</h3>
								<h3 *ngIf="showBlackbars() && ifwhitebar" class="cstmenu text-white showcls">Close</h3>
								<h3 *ngIf="showBlackbars() && ifblackbar"
									class="d-none d-sm-none d-md-none d-lg-block cstmenu showcls2">Menu</h3>
								<h3 *ngIf="showBlackbars() && ifwhitebar"
									class="d-none d-sm-none d-md-none d-lg-block cstmenu text-white showcls2">Menu</h3>
							</div>
							<div class="menu" id="menu">
								<!-- *ngIf="!isMenuActive" -->
								<a href="/" routerLinkActive="router-link-active"><img *ngIf="showBlackbars() && ifblackbar"
										class="logo" src="{{baseUrl}}/img/logos/pixtar-main-logo.webp"
										alt="website development company dubai" height="50" width="160" (click)="selectLink('/')" loading="lazy"></a>
								<!-- <a [routerLink]="['/']" routerLinkActive="router-link-active"><img *ngIf="showBlackbars() && ifwhitebar" class="logo" src="{{baseUrl}}/img/logos/pixtar_white.svg"
									alt="best design agency" width="40" (click)="selectLink('/')"></a> -->
								<img *ngIf="showBlackbars() && ifwhitebar" src="{{baseUrl}}/img/logos/pixtar-main-logo-white.webp"
									alt="Top creative agencies in dubai" width="160" height="50" class="logo" (click)="selectLink('/')" loading="lazy">
								<div class="menu-inner">
									<ul class="menu-nav" id="navMenus">
										<li class="menu-nav-item" id="home"><a class="menu-nav-link" [routerLink]="['/']"
												routerLinkActive="router-link-active" (click)="selectLink('/')"><span>
													<div>
														<img *ngIf="showBlackbars() && ifblackbar" src="{{baseUrl}}/img/home/home.png" height="40"
															width="43" alt="web development company dubai" class="menuhome" (mouseenter)="func4()"
															(mouseleave)="func5()" loading="lazy">
														<img *ngIf="showBlackbars() && ifwhitebar" src="{{baseUrl}}/img/home/homewhite.png"
															height="40" width="43" alt="website developers in dubai" class="menuhome"
															(mouseenter)="func4()" (mouseleave)="func6()" loading="lazy">
													</div>
												</span></a></li>
										<li class="menu-nav-item" id="services">

											<span class="list1">
												<a class="menu-nav-link" [routerLink]="['/services']" routerLinkActive="router-link-active"
													(click)="selectLink('services')">

													<span>
														<div>Services</div>
													</span>
												</a>
											</span>

											<ul class="d-flex sub-service ps-0">
												<li class="menu-nav-item" id="branding">
													<a class="menu-nav-link hover-underline-animation" href="/services/branding"
														(click)="selectLink('services/branding')">
														<span>
															<div>Branding</div>
														</span>
													</a>
												</li>
												<li class="menu-nav-item" id="graphics">
													<a class="menu-nav-link hover-underline-animation" href="/services/graphics"
														(click)="selectLink('graphics')">
														<span>
															<div>Graphics</div>
														</span>
													</a>
												</li>
												<li class="menu-nav-item" id="website">
													<a class="menu-nav-link hover-underline-animation" href="/services/website-development"
														(click)="selectLink('website')">
														<span>
															<div>Website</div>
														</span>
													</a>
												</li>
												<li class="menu-nav-item" id="ecommerce">
													<a class="menu-nav-link hover-underline-animation" href="/services/ecommerce-web-development"
														(click)="selectLink('ecommerce-web-development')">
														<span>
															<div>Ecommerce</div>
														</span>
													</a>
												</li>
											</ul>
										</li>


										<li class="menu-nav-item" id="studio"><a class="menu-nav-link" [routerLink]="['/studio']"
												routerLinkActive="router-link-active" (click)="selectLink('studio')">
												<span>
													<div>Studio</div>
												</span></a>
										</li>
										<li class="menu-nav-item" id="projects"><a class="menu-nav-link" [routerLink]="['/projects']"
												routerLinkActive="router-link-active" (click)="selectLink('projects')">
												<span>
													<div>Projects</div>
												</span></a>
										</li>
										<!-- <li class="menu-nav-item" id="about"><a class="menu-nav-link" (click)="selectLink('about')">
												<span>
													<div>About</div>
												</span></a>
										</li> -->
										<!-- <li class="menu-nav-item" id="ecommerce"><a class="menu-nav-link" (click)="selectLink('ecommerce')">
												<span>
													<div>eCommerce</div>
												</span></a>
										</li>
										<li class="menu-nav-item" id="graphics"><a class="menu-nav-link" (click)="selectLink('graphics')">
											<span>
												<div>Graphics</div>
											</span></a>
										</li> -->
										<li class="menu-nav-item" id="process"><a class="menu-nav-link" [routerLink]="['/process']"
												routerLinkActive="router-link-active" (click)="selectLink('process')">
												<span>
													<div>Process</div>
												</span></a>
										</li>

										<!-- <li class="menu-nav-item" id="website"><a class="menu-nav-link" (click)="selectLink('website')">
											<span>
												<div>Website</div>
											</span></a>
										</li> -->
										<li class="menu-nav-item" id="blog"><a target="_blank" [routerLink]="['/blog']"
												routerLinkActive="router-link-active" class="menu-nav-link" (click)="selectLink('blog')">
												<span>
													<div>Blogs</div>
												</span></a>
										</li>
										<li class="menu-nav-item" id="contact"><a class="menu-nav-link lastanch"
												(click)="selectLink('contact')" [routerLink]="['/contact']"
												routerLinkActive="router-link-active">
												<span>
													<div class="d-flex flex-row">Contact
														<img src="{{baseUrl}}/img/home/contactarrow.svg" alt="web development dubai" height="42"
															width="30" class="arrowimg" loading="lazy">
													</div>
												</span></a>
										</li>
									</ul>
									<div class="gallery">
										<div class="position-absolute  menu-left-content">
											<p>Creative agency based in Dubai, </p>
											<p>United Arab Emirates</p>
											<!-- <p class="text-color">+971 52 7930781</p> -->
											<p class="mt-2" *ngIf="showBlackbars() && ifblackbar">
												<a class="me-2" href="https://www.instagram.com/pixtar.ae/" target="_blank">
													<img src="{{baseUrl}}/images/instagram.svg" alt="ecommerce website design in dubai" height="30"
														width="30" loading="lazy">
												</a>
												<a class="me-2" href="https://www.facebook.com/pixtar.ae/" target="_blank">
													<img src="{{baseUrl}}/images/facebook.svg" alt="graphic design company" width="30" height="30" loading="lazy">
												</a>

												<a class="me-2" href="https://www.linkedin.com/company/pixtar-ae/" target="_blank">
													<img src="{{baseUrl}}/images/linkedin.svg" alt="Best Web Designers in Dubai" width="30" height="30" loading="lazy">
												</a>
												<a class="whatsapp-icon2 slideUpReturn tabmob" href="https://wa.me/+971527930781"
													target="_blank">
													<img src="{{baseUrl}}/img/home/whatsapp.svg" alt="Branding agency in Dubai " height="30"
														width="30" loading="lazy">
												</a>
											</p>

											<p class="mt-2" *ngIf="showBlackbars() && ifwhitebar">
												<a class="me-2" href="https://www.instagram.com/pixtar.ae/" target="_blank">
													<img src="{{baseUrl}}/images/instagram-white.svg" alt="Creative agency Dubai" width="30" height="30" loading="lazy">
												</a>
												<a class="me-2" href="https://www.facebook.com/pixtar.ae/" target="_blank">
													<img src="{{baseUrl}}/images/facebook-white.svg" alt="rebranding agency dubai" width="30" height="30" loading="lazy">
												</a>
												<a class="me-2" href="https://www.linkedin.com/company/pixtar-ae/" target="_blank">
													<img src="{{baseUrl}}/images/linkedin-white.svg" alt="best web design company in dubai"
														width="30" height="30" loading="lazy">
												</a>
												<a class="whatsapp-icon2 slideUpReturn tabmob" href="https://wa.me/+971527930781"
													target="_blank">
													<img src="{{baseUrl}}/img/home/whatsapp-white.svg" alt="Top branding agency in Dubai"
														width="30" height="30" loading="lazy">
												</a>
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</nav>
